import React, { useContext } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import useCWPContext from '../context/useCWPContext';

export default function ApprovedAllModal() {
  const { approvedAllModal, handleCloseApproveAllModal } = useContext(useCWPContext);
  return (
    <Dialog open={approvedAllModal} onClose={handleCloseApproveAllModal} maxWidth='sm' fullWidth>
      <DialogTitle>Approved All</DialogTitle>
      <DialogContent dividers />
      <DialogActions />
    </Dialog>
  );
}
